module.exports = __webpack_public_path__ + "static/img/8.93861fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/eng/8.png
// module id = 0VA8
// module chunks = 0